<template>
  <div>
    <v-icon class="login-icon no-select">
      fas login
    </v-icon>
    <p class="init-headline">Bienvenido!</p>
    <p class="init-text">Para ingresar a tu campaña asignada</p>
    <p class="init-text">haz click en "Conectar a campaña"</p>
    <v-btn  
    :disabled="loading"
    class="k-orange-linear white--text mt-5" block large
    @click="$emit('start-campaign')">
      Conectar a campaña
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style scoped>
.init-headline {
  font-weight: bolder;
  font-size: 30px !important;
  text-align: center;
  margin-top: 30px;
}

.init-text {
  text-align: center;
  margin: 0;
  font-size: 16px;
}

.login-icon {
  text-align: center;
  display: flex;
  margin: auto;
  margin-left: -70px;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 100px;
  width: 100px;
  color: #2e2e44;
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/ConnectionStages/ConnectCampaign.vue